<template>
  <div>
    <a-form-model  layout="horizontal" :model="model" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 },}" ref="ruleForm" :rules="rules">
      <a-form-model-item  label='公式类型' prop='type' >
        <a-radio-group v-model="model.type" size="small">
          <a-radio-button value="1">
            量表计算
          </a-radio-button>
          <a-radio-button value="2">
            数据填入
          </a-radio-button>
          <a-radio-button value="3">
            级联填入
          </a-radio-button>
          <!--<a-radio-button value="4">-->
            <!--测评结果-->
          <!--</a-radio-button>-->
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item  label='排序' prop='sortNum' >
        <a-input-number v-model="model.sortNum" placeholder="请输入排序" :min="0" :precision="0" style="width: 100px"/>
      </a-form-model-item>
      <a-form-model-item  label='公式更新表单' prop='formId' >
        <a-select v-model='model.formId' placeholder='请选择公式更新表单' @change="formIdChange()" showSearch :filterOption="filterOption">
          <a-select-option :value='item.id' :key="item.id" v-for="item in formList">{{item.name}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item  label='公式更新元素' prop='formItemId' >
        <a-select v-model='model.formItemId' placeholder='请选择公式更新元素' @change="formItemIdChange" showSearch :filterOption="filterOption" >
          <a-select-option :value='item.id' :key="item.id" v-for="item in formItemList">{{(item.number?item.number:"")+item.name}}</a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
  import { getAction } from '@/api/manage'
  import baseRules from '@/constants/baseRules'
export default {
  name: 'Step1',
  data() {
    return {
      rules: {
        formId:[baseRules.requiredChange],
        formItemId:[baseRules.requiredChange],
        sortNum:[baseRules.required],
        type:[baseRules.requiredChange],
      },
      formList:[],
      formItemList:[],
      model:{},
    }
  },
  created() {


  },
  methods: {
    view(model){
      this.model = JSON.parse(JSON.stringify(model))

      if (this.model.selectForm && this.model.selectItem) {
        this.formList = [];
        this.formItemList = [];

        this.model.sortNum = 1;
        this.model.formId = this.model.selectForm.id;
        this.model.formItemId = this.model.selectItem.id;

        this.formList.push(this.model.selectForm);
        this.formItemList.push(this.model.selectItem);

        this.formItemIdChange();
      } else {
        getAction('/tempconfig/tempConfigForm/listAll',{}).then(res=>{
          if(res.success){
            this.formList=res.result
            this.formIdChange(true)
          }else{
            this.$message.error(res.result)
          }
        })
      }
    },
    /**
     * 当前步骤表单验证逻辑
     */
    validate() {
      let result = false
      this.$refs.ruleForm.validate((valid, errorFields) => {
        if (valid) {
          result = true
        }
      })
      return result
    },
    formItemIdChange(){      
      let formItem = null
      if(this.model.formItemId){
        getAction('/tempconfig/tempConfigFormItem/queryById',{id:this.model.formItemId}).then(res=>{
          if(res.success){
            formItem = res.result
            this.$set(this.model,'formItem',formItem)
            if(!formItem.dictItemList && formItem.dictItemJson){
              formItem.dictItemList = JSON.parse(formItem.dictItemJson)
            }
          }
        })
      }
      else{
        formItem = null
        this.$set(this.model,'formItem',formItem)
      }
    },
    formIdChange(edit){
      this.formItemList = []
      if(this.model.formItemId && !edit){
        this.model.formItemId = null
      }
      if(this.model.formId){
        let formCode;
        for (let item of this.formList) {
          if (item.id === this.model.formId) {
            formCode = item.code
            break
          }
        }
        getAction('/tempconfig/tempConfigFormItem/listAll',{formCode:formCode}).then(res=>{
          if(res.success){
            this.formItemList = res.result
            this.formItemIdChange()
          }
        })
      }
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
  }
}
</script>

<style scoped>

</style>
